import Swal from 'sweetalert2'
import {
    RECOVER_EMAIL,
    RECOVER_CODE,
    RECOVER_PASSWORD,
    IS_LOADING_RECOVER_CODE,
    RESET_PASSWORD
} from './types'
import { urlServer } from '../config/GlobalConstant'
import inMemoryJWT from '../auth/inMemoryJwt';
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

//recover password in login and profile actions
export const sendEmailToPassword = (email, history) => async dispatch => {
    console.log()
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_RECOVER_CODE,
    });

    await fetch(`${urlServer}static-routes/restore/request-code`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        // credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify({
            email: email
        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            var errorType = respJson.error
            var success = respJson.success

            if (respJson.success === true) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Se ha enviado un código de verificación a tu correo'
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: RECOVER_EMAIL,
                    payload: { email, errorType, success }
                });
                history.push({
                    pathname: '/RecoverPasswordCode',
                    state: {
                        email: email,
                    }
                })
            }


        })

        .catch(error => {
            console.log()
        })

}

export const sendCodeToPassword = (code, email, history) => async dispatch => {

    console.log()

    await fetch(`${urlServer}static-routes/restore/verify-code`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            //'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify({
            code: code,
        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            var errorType = respJson.error
            var success = respJson.success
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: RECOVER_CODE,
                payload: { success, errorType, code }
            });
            console.log()
            if (respJson.success === true) {
                history.push({
                    pathname: '/RecoverPasswordConfirm',
                    state: {
                        email: email,
                        code: code
                    }
                })
            }

            if (respJson.success === false) {
                Toast.fire({
                    icon: 'error',
                    title: 'Código no válido'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const sendRecoverUser = (email, password, history) => async dispatch => {
    console.log({
        password,
        email,
    })


    if (true) {
        await fetch(`${urlServer}static-routes/restore/password`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            //withCredentials: true,
            //credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },

            body: JSON.stringify({
                password: password,
                email: email,
            }) // body data type must match "Content-Type" header      
        })
            .then(response => response.json())
            .then(respJson => {
                console.log()
                var errorType = respJson.error
                var success = respJson.success
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: RECOVER_PASSWORD,
                    payload: { success, errorType }
                });

                if (respJson.success === true) {
                    history.push('/')
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 2000,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'success',
                        title: 'Contraseña configurada correctamente'
                    })
                }
                if (respJson.success === false) {
                }
            })
            .catch(error => {
                console.log()
            })
    }


}

export const sendNewPassword = (userNewPassword, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}users/change-password`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify(
            userNewPassword
        ) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {

            if (!respJson.success) throw respJson;

            console.log()
            var errorType = respJson.error
            var success = respJson.success
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: RESET_PASSWORD,
                payload: { success, errorType }
            });
            if (respJson.success === true) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Contraseña configurada correctamente'
                })
                history.push("/")
            }
            if (respJson.success === false) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'error',
                    title: 'Error al configurar la contraseña'
                })
            }
        })
        .catch(error => {
            console.log();
            Toast.fire({
                icon: "error",
                title: "error al cambiar la contraseña"
            })
        })
}